import { ConceptFlowWaveBar } from "@/app/types/home/ConceptFlow";
import { waveBarStyle } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

type Props = {
  bars: ConceptFlowWaveBar[];
  className?: string;
};

export default function ConceptFlowWaveform(props: Props) {
  const { bars, className } = props;

  return (
    <span className={`${styles.wave} ${className ?? ""}`}>
      {bars.map((bar, index) => (
        <span className={styles.waveBar} key={bar.id} style={waveBarStyle(bar, index)} />
      ))}
    </span>
  );
}
